import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'
import ReviewForm from './form';

export default function Main() {
  const [name, setName] = useState('')
  const [review, setReview] = useState('')
  const [img, setImg] = useState('')
  const [rating, setRating] = useState(5)
  const [sort, setSort] = useState('0')
  const [status, setStatus] = useState('1')

  const id = new URLSearchParams(window.location.search).get("id")

  useEffect(() => {
    getbyid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getbyid = async () => {
    const data = new FormData();
    data.append('id', id);
    axios({
      method: 'post',
      url: '/api/review/get_byid.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (!s.data.length) return
        setName(s.data[0].name)
        setReview(s.data[0].review)
        setImg(s.data[0].img)
        setRating(Number(s.data[0].rating) || 5)
        setSort(String(s.data[0].sort))
        setStatus(String(s.data[0].status))
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const getDb = async () => {
    if (name.trim() === '' || review.trim() === '') {
      alert("Name aur Description dono zaroori hain.")
      return
    }
    const data = new FormData();
    data.append('id', id);
    data.append('name', name);
    data.append('review', review);
    data.append('img', img);
    data.append('rating', rating);
    data.append('sort', sort);
    data.append('status', status);
    axios({
      method: 'post',
      url: '/api/review/update.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (s.data[0].msg === "pass") {
          alert("Updated.")
        } else {
          alert("Not update try again !")
        }
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card modern-card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div>
                          <h4 className="mb-1">Update Review</h4>
                          <span className="opacity-75">Editing: {name || 'Loading...'}</span>
                        </div>
                        <span className="badge bg-light text-dark ms-auto py-2 px-3">Edit Mode</span>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <ReviewForm
                          name={name} setName={setName}
                          review={review} setReview={setReview}
                          img={img} setImg={setImg}
                          rating={rating} setRating={setRating}
                          sort={sort} setSort={setSort}
                          status={status} setStatus={setStatus}
                        />
                        <div className="col-lg-12 d-flex justify-content-end mt-4">
                          <a href="viewreview" className="btn btn-light px-4 me-2">Back</a>
                          <button className="btn btn-primary px-4" onClick={() => { getDb(); }}>
                            Update Review
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}
